import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  TOW_PRO,
  setPinnedLocation,
} from '@rsos/reduxDataStore/src/features/geoSelection/geoSelectionSlice';

interface Coordinates {
  latitude: number;
  longitude: number;
}

/**
 * Pins a tow request's location on the map for as long as the calling
 * component is shown.
 */
export function useTowProMapPin(location: Coordinates): void {
  const dispatch = useDispatch();
  const { latitude, longitude } = location;

  useEffect(() => {
    dispatch(
      setPinnedLocation({ key: TOW_PRO, location: { latitude, longitude } }),
    );
    return () => {
      dispatch(setPinnedLocation({ key: TOW_PRO, location: null }));
    };
  }, [dispatch, latitude, longitude]);
}
